import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link, withRouter } from 'react-router-dom';
import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;
var fs = require('browserify-fs');

class Footer extends Component {
    constructor(props) {
        super(props);
 
        this.state = {
          
          Aboutus:[],
          defaultlang:6,
          Siteconfig:[],
          languagedata:[],
      
      
        };
       
        
    }
    componentWillMount() {
      const deflang= localStorage.getItem('DefaultLanguage');
        if(deflang == null){
           localStorage.setItem('DefaultLanguage',6);
        }
  const DefaultLang = localStorage.getItem('DefaultLanguage');

  this.setState({defaultlang: DefaultLang});


  if(localStorage.getItem('SiteconfigObj')!=null){
      const SiteconfigObj=JSON.parse(localStorage.getItem('SiteconfigObj'));
       this.setState({Siteconfig:SiteconfigObj});
  }else{
  this.getsiteconfig(DefaultLang);
  }



  
} 

    getsiteconfig(DefaultLang){
      axios.post(`${API_URL}/siteconfig`, { LanguageId : 6}).then(res => {
            if(res.data.Status == 1)
            {
              const Siteconfig = res.data.ResponseData[0];
               localStorage.setItem('SiteconfigObj',JSON.stringify(Siteconfig));
              this.setState({ Siteconfig });
              
            }else{
              this.setState({ Siteconfig:[] });
            }
            
        })
    }

  render() {
    return (
      <footer>
  <div className="container">
    <div className="row">
      <div className="col-xl-5 col-lg-5 col-md-6">
        <h3>{this.props.languagedata.about_us}</h3>
        <p >{this.props.languagedata.about_us_detail}</p>
        <div className="terms-privacy">
        <Link to="/terms">{this.props.languagedata.terms}</Link>
        <Link to="/privacy-policy">{this.props.languagedata.privacy_policy}</Link>
        
        </div>
      </div>
      <div className="col-xl-4 col-lg-4 col-md-6">
        <ul className="list-unstyled">
          <li><i className="fa fa-map-marker"></i> <p dangerouslySetInnerHTML={{__html: this.state.Siteconfig.Siteaddress}} ></p></li>
          <li>
            <i className="fa fa-envelope"></i> 
            <a> {this.state.Siteconfig.Siteemail}</a>
          </li>
        </ul>
        <Link to={this.props.match.path == "/Donate" ? this.props.location.pathname+""+this.props.location.search : "/Donate" } className="footer_donate">{this.props.languagedata.donate_now}</Link>
        
      </div>
      <div className="col-xl-3 col-lg-3 col-md-12">
        <div className="footer_logo">
          <a href="http://www.webmyne.com/" target="_blank">
            <img src={ IMAGE_URL+'/images/footer-logo.png' } alt="Swacch Bharat"/> 
          </a>         
        </div> 
        <div className="social_link">
          <a href={this.state.Siteconfig.Facebooklink} target="_blank"> 
          <img src={ IMAGE_URL+'/images/social-1.png' } alt="facebook"/> </a>
          <a href={this.state.Siteconfig.Rsslink} target="_blank"> 
          <img src={ IMAGE_URL+'/images/social-2.png' } alt="rss" /></a>
          <a href={this.state.Siteconfig.Youtubelink} target="_blank"> 
          <img src={ IMAGE_URL+'/images/social-3.png' } alt="youtube"/> </a>
          <a href={this.state.Siteconfig.Twitterlink} target="_blank"> 
          <img src={ IMAGE_URL+'/images/social-4.png' } alt="twitter"/> </a>
          <a href={this.state.Siteconfig.Googlelink} target="_blank"> 
          <img src={ IMAGE_URL+'/images/social-5.png' } alt="google"/> </a>
          <p className="text-center">©2019 Webmyne NGO.</p>
        </div>

          
        
        
      </div>
    </div>
  </div>
</footer>
    );
  }
}

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/layout/Footer.js